/**
 * Created by Mikhail Menshenin on 09.07.2024
 */

class VillageSceneComponent extends ScriptComponent {
    onCreate() {
        this.args = PrefabBuilder.resolveProperty(this.options.args, this.context) || {};
        this.village = this.args.village || cleverapps.meta.getSelectedLocation().village;
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setBundles(this.listBundles());

        this.resolutionMode = cleverapps.resolution.mode;
    }

    onSceneLoaded() {
        this.addVillage();
        this.addUI();
        this.addExclamation();

        cleverapps.UI.onClick(this.node, this.onClick.bind(this), {
            onDoubleClick: this.onDoubleClick.bind(this),
            interactiveScale: false
        });

        if (this.village.isStateBuild()) {
            this.village.checkAttention();
        }

        if (this.village.isFirstInit()) {
            this.firstInit();
        }
    }

    onClick(touch) {
        this.villageView.checkTouch(touch, false);
    }

    onDoubleClick(touch) {
        this.villageView.checkTouch(touch, true);
    }

    onResize() {
        if (this.resolutionMode === cleverapps.resolution.mode) {
            return;
        }

        this.resolutionMode = cleverapps.resolution.mode;

        cleverapps.bundleLoader.loadBundles([this.village.getBackgroundBundle()], {
            onSuccess: () => {
                if (this.node.background) {
                    this.node.background.removeFromParent();
                }
                this.sceneComponent.setStyling(this.getBackgroundStyles());
                this.sceneComponent.setBackground();
                this.addVillage();
            }
        });
    }

    addVillage() {
        if (this.villageControl) {
            this.villageControl.removeFromParent();
        }

        this.villageView = new VillageView(this.village);
        this.villageControl = VillageSceneComponent.AddControl(this.node.background || this.node, this.villageView, {
            direction: HidingComponent.DIR.NONE,
            control: "village"
        }, {
            x: { align: "center" },
            y: { align: "center" }
        });
    }

    addUI() {
        this.addProgress();
        this.addHammer();
    }

    addProgress() {
        const progress = new VillageProgressView(this.village);
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            progress.setScale(0.8);
        }

        this.progressControl = VillageSceneComponent.AddControl(this.node, progress, {
            direction: HidingComponent.DIR.NONE,
            control: "progress"
        }, cleverapps.styles.VillageScene.progress.position);
    }

    addHammer() {
        this.hammer = new VillageHammerView(this.village);

        VillageSceneComponent.AddControl(this.node, this.hammer, {
            direction: HidingComponent.DIR.NONE,
            control: "hammer"
        }, cleverapps.styles.VillageScene.hammer.position);
    }

    addExclamation() {
        const exclamationView = new ExclamationView();
        exclamationView.setLocalZOrder(30);
        exclamationView.setAlignment(cleverapps.styles.VillageScene.exclamation);
        this.node.addChild(exclamationView);
    }

    firstInit() {
        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "VillageBuildForce",
            control: "hammer",
            action: (f) => {
                cleverapps.forces.create(this.hammer, {
                    text: "Tutorial.CoinKingdom.HammerForce"
                });
                cleverapps.forces.onceForceClosed = f;
            }
        });
    }

    finish() {
        cleverapps.focusManager.display({
            focus: `${cleverapps.environment.scene}Finish`,
            action: (f) => {
                this.village.receiveGold();
                CoinKingdom.OpenSlotMachine(f);
            }
        });
    }

    getBackgroundStyles() {
        return {
            bundle: this.village.getBackgroundBundle(),
            backgroundId: "background"
        };
    }

    listBundles() {
        return ["village", this.village.getBackgroundBundle(), this.village.getBundleId()];
    }

    static AddControl(parent, view, options, alignment) {
        const control = new cc.Node();
        control.addChild(view);
        parent.addChild(control);

        ComponentMap.attach(control, new HidingComponent(options));

        if (alignment) {
            control.setAlignment(alignment);
        }

        return control;
    }

    static GetRunning() {
        return ComponentMap.get(cleverapps.Scenes.GetRunningScene(), VillageSceneComponent);
    }
}

Prefab.registerComponent("VillageSceneComponent", VillageSceneComponent);

cleverapps.styles.VillageScene = {
    exclamation: {
        x: { align: "center" },
        y: { align: "center" }
    },

    hammer: {
        position: [{
            x: { align: "left", dx: 31 },
            y: { align: "bottom", dy: 20 }
        }, {
            x: { align: "left", dx: 103 },
            y: { align: "bottom", dy: 34 }
        }, {
            x: { align: "left", dx: 103 },
            y: { align: "bottom", dy: 34 }
        }]
    },

    progress: {
        position: [{
            x: { align: "center", dx: 10 },
            y: { align: "bottom", dy: 180 }
        }, {
            x: { align: "center", dx: 25 },
            y: { align: "bottom", dy: 140 }
        }, {
            x: { align: "center", dx: 25 },
            y: { align: "bottom", dy: 140 }
        }]
    }
};

RestoreProgressButton.OverlappingNodes = RestoreProgressButton.OverlappingNodes.concat(["hammer", "village"]);
